import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import routes from 'app/routes';

import 'app/styles/main.css';

const router = createBrowserRouter(routes);

const Root = () => (<RouterProvider router={router} />);

export default Root;
